import { createErrorWrapper } from '../utils';

export const LOAD_ERROR = 'BLOG.LOAD_ERROR';

export const loadErr = createErrorWrapper(LOAD_ERROR, 'Failed to load blog posts');
